import Ads from './ads/ads'
import _ from 'lodash'
import Analytics from './EfeAnalytics'

(function () {
    const ver = '1.1.1';
    Analytics.sendEvent('dev', 'init', ver);
    console.log(`v${ver}`);
    const contentEl = document.getElementById('content');

    function doMobileLogic() {
        $('#content').append('<h1>More topics:</h1></h1><ul class="navigation">'+$('#leftNav ul.nav-items-container').html()+'</ul>');
        var isMenuExpanded = false;
        function toggleMenu() {
            isMenuExpanded = !isMenuExpanded;
            $('#leftNav ul.nav-items-container').toggle();
            $('#mobile-menu').html('<ul><li>'+(isMenuExpanded ? 'Close' : 'Open')+' Menu <div style="display: inline-block; float: right;">=</div></li></ul>')
        }
        $('#mobile-menu').show();
        $('#mobile-menu').click(toggleMenu);
    }

    var screenWidth = $('body').width();
    if (screenWidth <= 900) { //mobile
        doMobileLogic();
    } else {
        let contentHeight = $('#content').height();
        let navHeight = $('aside').height();
        let roomForLeftNavAd = contentHeight - navHeight;
        $('#left-nav-footer').height(roomForLeftNavAd);
        let sideAdSizing = {
            width:  $('#left-nav-footer').width(),
            height: $('#left-nav-footer').height()
        }
        let headerFooterAdSizing = {
            width:  $('#left-nav-footer').width(),
        }
    }
    Ads.bind(adjustAdSizes);


    function adjustAdSizes(placementName, sizes) {
        if (screenWidth <= 900) { //mobile

        } else {
            if (placementName === 'aside') sizes = adjustSidebarAdSizes(sizes);
            if (placementName === 'center') sizes = adjustCenterAdSizes(sizes);
        }
        return sizes;
    }

    function adjustSidebarAdSizes(sizes) {
        sizes = _.filter(sizes, size => !_.isArray(size) || size[0] == 1 ? size : size[1] < $('#left-nav-footer').height());
        sizes = _.filter(sizes, size => !_.isArray(size) || size[0] == 1 ? size : size[0] < $('#left-nav-footer').width());
        if (sizes.length == 1 && sizes[0] == 1) return [];
        return sizes;
    }

    function adjustCenterAdSizes(sizes) {
        sizes = _.filter(sizes, size => !_.isArray(size) || size[0] == 1 ? size : size[0] < $('.content').width());
        return sizes;
    }


})();
